import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chess-fest',
  templateUrl: './chess-fest.component.html',
  styleUrls: ['./chess-fest.component.scss']
})
export class ChessFestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
